module.exports = __webpack_public_path__ + "img/student_1.37e78f23.png";